import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
import { ImageAssetSchema } from '../ui/imageAsset';
const ResourceFormatSchema = z.enum([
    'website',
    'video',
    'audio',
    'document',
    'article'
]);
export const ResourceSchema = z.object({
    _id: z.string(),
    name: I18nStringSchema,
    source: z.string(),
    description: I18nStringSchema,
    previewImage: ImageAssetSchema.optional(),
    format: ResourceFormatSchema,
    link: z.string()
});
//# sourceMappingURL=resource.js.map